module.exports = __webpack_public_path__ + "img/Victor Gaston.5fcf711d.jpg";